import { OriginEnum } from './medicine';

export interface TipoExameFormulario {
  Chave: 'FORMULARIO_APAC' | 'FORMULARIO_BPA-I' | null;
  Nome: string;
  idTipoExameFormulario: number;
}

export interface ExamSearch {
  AnestesiaRequerida: boolean;
  CodigoTUSS: string;
  Label: string;
  LadoRequerido: boolean;
  Nome: string;
  idEzOrder: number;
  categoria: string;
  idExterno: string;
  sigtap: string;
  tipoExameFormulario?: TipoExameFormulario[];
  referencia: string | null;
  ReferenciaExterna: string | null;
  OrigemExame: string | null;
  customExamIndex?: string | null;
}

export interface FavoriteExam {
  examId: string;
  idEzOrder: number;
  sigtap: string;
  name: string;
  codeTuss: string;
  requiresSide: boolean;
  requiresAnesthesia: boolean;
  label: string;
  category: string;
  externalId: string;
  referencia: string;
  externalReference: string;
  examOrigin: string;
  customExamIndex?: string | null;
}

export interface Cid {
  Codigo: string;
  idCID10: number;
  Descricao: string;
}

export interface Exam extends ExamSearch {
  AplicarAnestesia: boolean;
  Instrucoes: string;
  Lateralidade: LATERALITY | null;
  idPrescricaoExame?: number;
  CID10Estruturado?: Cid[];
  tipoFormulario: TipoExameFormulario | null;
  examId: string;
  Origem?: OriginEnum;
  QuandoRealizar?: string | null;
  DataEspecifica?: Date | null;
  QuantidadeSessoes?: number | null;
  customExamIndex?: string | null;
  AdicionadoPorIA?: boolean;
  CidEspecifico?: boolean;
  ObservacaoEspecifica?: boolean;
}

export enum LATERALITY {
  LEFT = 'Esquerdo',
  RIGHT = 'Direito',
  BOTH = 'Ambos',
}
